<div class="row">
  <div class="col-md-12">
    @if (hasEditPermissions) {
      <button
        mat-raised-button
        class="edit-button"
        (click)="saveDates()"
        [disabled]="!checkDates()"
        [ngClass]="!checkDates() ? 'disabled' : ''">
        @if (!isEditMode) {
          <span>Edit</span>
        }
        @if (isEditMode) {
          <span>Save</span>
        }
      </button>
    }
    @if (isEditMode && hasEditPermissions && availableDates.length > 0) {
      <button
        mat-raised-button
        class="add-date"
        [matMenuTriggerFor]="menu"
        [disabled]="!checkDates()"
        [ngClass]="!checkDates() ? 'disabled' : ''">
        Add Date
      </button>
    }
    <mat-menu #menu="matMenu">
      @for (date of availableDates; track date; let i = $index) {
        <button
          mat-menu-item
          (click)="addDate(date, i)">
          {{ date.name }}
        </button>
      }
    </mat-menu>
  </div>
</div>

@if (projectDates.length > 0) {
  <div class="mat-elevation-z8">
    <table mat-table class="stripped-table" [dataSource]="dataSource" matSort>
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td
          mat-cell
          class="name-column"
          *matCellDef="let row"
        [ngClass]="
          row.name === 'LOI Expiration Date' && flagLOIExpiration && !isEditMode
            ? 'loi-expiration'
            : ''
        ">
          {{ row.name }}
        </td>
      </ng-container>
      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td
          mat-cell
          *matCellDef="let row; let i = index"
        [ngClass]="
          row.name === 'LOI Expiration Date' && flagLOIExpiration && !isEditMode
            ? 'loi-expiration'
            : ''
        ">
          @if (
            !(row.hasPermission || row.permissions?._edit) ||
            !isEditMode ||
            row.dateType === 'diligence'
            ) {
            <span
              class="value-column"
              >
              @if (row.isTarget && row.name !== 'LOI Closing Date') {
                <mat-icon
                  class="target-icon"
                  matTooltip="Target Date"
                  >flare</mat-icon
                  >
                }
                {{ row.date }}
              </span>
            }
            @if (
              (row.hasPermission || row.permissions?._edit) &&
              isEditMode &&
              row.dateType !== 'diligence'
              ) {
              <span
                class="value-column"
                >
                @if (
                  row.name !== 'LOI Expiration Date' &&
                  row.name !== 'LOI Closing Date' &&
                  row.name !== 'LOI Maturity' &&
                  row.name !== 'Effective Closing Date'
                  ) {
                  <mat-checkbox
                    [(ngModel)]="row.newIsTarget"
                    >Target</mat-checkbox
                    >
                  }
                  <mat-form-field appearance="fill">
                    <mat-label>Enter a date</mat-label>
                    <input
                      matInput
                      [matDatepicker]="datepicker"
                      (dateChange)="changeDate($event, i)"
                      [value]="row.newdate"
                      required />
                    <mat-datepicker-toggle
                      matIconSuffix
                    [for]="datepicker"></mat-datepicker-toggle>
                    <mat-datepicker #datepicker> </mat-datepicker>
                  </mat-form-field>
                  <button
                    mat-icon-button
                    color="warn"
                    aria-label="Delete Date"
                    (click)="deleteDate(row, i)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </span>
              }
              @if (!checkDate(row.newdate)) {
                <div class="row">
                  <div class="col-md-12 date-error-text">
                    <small class="error-text"> Enter a valid date </small>
                  </div>
                </div>
              }
            </td>
          </ng-container>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    }

    @if (projectDates.length <= 0) {
      <div>
        <i>There are no deal dates for this deal.</i>
      </div>
    }
